import { AnonymousCredential, BlockBlobClient, newPipeline } from "@azure/storage-blob";

import { Plugin } from '@uppy/core';
import * as sanitize from 'sanitize-filename';
import { v4 as uuidV4 } from 'uuid';

export default class AzureUploader extends Plugin {
  constructor(uppy, opts) {
    super(uppy, opts);

    this.type = 'uploader';
    this.id = this.opts.id || 'AzureUploader';

    this.handleUpload = this.handleUpload.bind(this);
  }

  install() {
    this.uppy.addUploader(this.handleUpload);
  }

  uninstall() {
    this.uppy.removeUploader(this.handleUpload);
  }

  async handleUpload(fileIDs) {
    const {account, containerName, SAS} = await this.getUploadParameters();

    const promises = fileIDs.map((fileID) => {
      const file = this.uppy.getFile(fileID);
      const destination = this.destinationURL(file, account, containerName);

      this.uppy.emit('upload-started', file);

      return this.upload(file, destination, SAS)
        .then(() => {
          this.uppy.emit('upload-success', file, destination)
        });
    });
    return Promise.all(promises)
  }

  destinationURL(file, account, containerName) {
    const filename = `${sanitize(file.id)}-${uuidV4()}`;
    return `https://${account}.blob.core.windows.net/${containerName}/${filename}`;
  }

  async getUploadParameters() {
    return fetch(this.opts.tokenUrl)
      .then(response => response.json());
  }

  upload(file, destinationURL, SAS) {
    const blockBlobClient = new BlockBlobClient(
      destinationURL + '?' + SAS,
      newPipeline(new AnonymousCredential())
    );

    return blockBlobClient.uploadBrowserData(file.data);
  }
}
